'use client';

import React, { useState } from 'react';
import { Eye, Volume2, VolumeX, Maximize, Share2, Heart } from 'lucide-react';

export default function LivePlayer() {
  const [muted, setMuted] = useState(false);
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(1247);

  const handleLike = () => {
    if (!liked) {
      setLikeCount((c) => c + 1);
      setLiked(true);
    }
  };

  return (
    <div className="bg-foreground rounded-2xl overflow-hidden">
      {/* Stream area */}
      <div className="relative aspect-video bg-gradient-to-br from-foreground via-secondary/20 to-foreground flex items-center justify-center">
        {/* EN VIVO badge */}
        <div className="absolute top-4 left-4 flex items-center gap-1.5 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full live-pulse z-10">
          <span className="w-2 h-2 bg-white rounded-full dot-pulse" />
          EN VIVO
        </div>

        {/* Viewer count */}
        <div className="absolute top-4 right-4 flex items-center gap-1.5 bg-black/50 text-white text-xs font-semibold px-3 py-1.5 rounded-full backdrop-blur-sm z-10">
          <Eye size={12} />
          <span className="font-tabular">1,247</span> espectadores
        </div>

        {/* Meta glasses indicator */}
        <div className="absolute top-14 left-4 flex items-center gap-2 bg-black/40 text-white text-xs px-3 py-1.5 rounded-full backdrop-blur-sm z-10">
          <span>👓</span>
          Meta Glasses — POV Knitting
        </div>

        {/* Center stream mock */}
        <div className="relative z-10 text-center text-white px-8">
          <div className="text-7xl mb-4">🧶</div>
          <p className="text-xl font-bold mb-1">La Anfitriona está tejiendo en vivo</p>
          <p className="text-sm text-white/70 mb-4">
            Contando chismes mientras teje con sus lentes Meta 👓✨
          </p>
          <div className="inline-flex items-center gap-2 bg-primary/80 text-white px-5 py-2.5 rounded-xl text-sm font-semibold">
            🧶 Tejido del día: Chaleco lavanda para el invierno
          </div>
        </div>

        {/* Currently reading */}
        <div className="absolute bottom-4 left-4 right-4 bg-black/70 backdrop-blur-sm rounded-xl p-3 z-10">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-bold text-primary uppercase tracking-wider">📖 Contando ahora</span>
          </div>
          <p className="text-white text-sm font-medium leading-snug">
            "El dueño del negocio de la esquina tiene dos familias en la misma cuadra y ninguna sabe de la otra 🤯"
          </p>
        </div>
      </div>

      {/* Controls bar */}
      <div className="flex items-center justify-between px-4 py-3 bg-foreground/95">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMuted(!muted)}
            className="p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors"
            aria-label={muted ? 'Activar sonido' : 'Silenciar'}
          >
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          </button>
          <div className="w-24 h-1.5 bg-white/20 rounded-full">
            <div className="h-full w-3/4 bg-white rounded-full" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={handleLike}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all ${
              liked ? 'text-red-400' : 'text-white/60 hover:text-red-400'
            }`}
          >
            <Heart size={16} className={liked ? 'fill-red-400' : ''} />
            <span className="font-tabular">{likeCount}</span>
          </button>
          <button className="p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors" aria-label="Compartir">
            <Share2 size={18} />
          </button>
          <button className="p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors" aria-label="Pantalla completa">
            <Maximize size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}